const maxLength = (max) => (value) => {
    if (!value) return undefined;
    return value.length < max ? undefined : `Text should be less than ${max} characters`;
};

export default maxLength;
